import { render, staticRenderFns } from "./payment-transaction.vue?vue&type=template&id=85ea31ae&"
import script from "./payment-transaction.vue?vue&type=script&lang=js&"
export * from "./payment-transaction.vue?vue&type=script&lang=js&"
import style0 from "./payment-transaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports